"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const OBJ_1 = __importDefault(require("../../utils/OBJ"));
const react_1 = require("react");
const react_2 = require("react");
const useAdvancedState = (in_state, dependencies = []) => {
    const [org, setOrgData] = (0, react_1.useState)(OBJ_1.default.clone(in_state));
    const [tmp, setTmpData] = (0, react_1.useState)(OBJ_1.default.clone(in_state));
    //? ------------------------------ useEffect ------------------------------------------------
    (0, react_2.useEffect)(() => {
        const cloned = OBJ_1.default.clone(in_state);
        if (OBJ_1.default.equals(cloned, org))
            return;
        setTmpData(cloned);
        setOrgData(cloned);
    }, dependencies);
    (0, react_2.useEffect)(() => {
        if (OBJ_1.default.equals(tmp, org))
            return;
        setTmpData(OBJ_1.default.clone(org));
    }, [org]);
    function setOrg(p1, p2) {
        if (arguments.length === 1)
            return setOrgData(p1);
        if (arguments.length === 2)
            return setOrgData(s => new OBJ_1.default(s).inner(p1).set(p2));
    }
    function setTmp(p1, p2) {
        if (arguments.length === 1)
            return setTmpData(p1);
        if (arguments.length === 2)
            return setTmpData(s => new OBJ_1.default(s).inner(p1).set(p2));
    }
    function getOrg(key) {
        return new OBJ_1.default(org).inner(key).get();
    }
    function getTmp(key) {
        return new OBJ_1.default(tmp).inner(key).get();
    }
    // -----------------------------------------------------------------------------------------
    return {
        tmp,
        org,
        set: { org: setOrg, tmp: setTmp },
        get: { org: getOrg, tmp: getTmp },
        changed: (0, react_2.useMemo)(() => !OBJ_1.default.equals(org, tmp), [org, tmp]),
        discard: (0, react_1.useCallback)(() => setTmpData(org), [in_state, org]),
    };
};
exports.default = useAdvancedState;
